import Vue from 'vue'

import PerfectScrollbar from 'vue2-perfect-scrollbar'
import './vue2-perfect-scrollbar.css'

Vue.use(PerfectScrollbar)
